import * as React from "react";
import type { SVGProps } from "react";
const SvgTimerOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.8 1.287h5.287m4.174 5.565 2.087-2.087m0 0-1.252-1.252m1.252 1.252L21.6 6.017M9 4.716a9.183 9.183 0 0 1 11.348 11.56M18 20.098A9.183 9.183 0 0 1 2.4 13.53c0-2.24.802-4.292 2.135-5.886M2.4 3.687l18.6 18.6"
    />
  </svg>
);
export default SvgTimerOff;
